import { useMemo } from 'react'

import { getRouteApi } from '@tanstack/react-router'

import type { PageContext } from '@/features/ai/types'

const Route = getRouteApi('/_dashboard/air/case-management/$id')

/**
 * PageContext provider for the case-detail route.
 *
 * Returns `case_detail` with the active `case_id` from the route params.
 * Falls back to the `unsupported` variant if the id is somehow absent so the
 * backend (which 422s on unknown `page_type` values) still receives a valid
 * discriminated payload.
 */
export const useCasePageContext = (): PageContext => {
	const { id } = Route.useParams()

	// Memoize for a stable reference — `AIChatInner` writes this to a vanilla
	// store via `useEffect` keyed on the object identity.
	return useMemo<PageContext>(() => {
		if (!id) {
			return { page_type: 'unsupported', page_name: 'case-detail' }
		}

		return { page_type: 'case_detail', case_id: id }
	}, [id])
}
